export const cards = [
    {
        title: 'Building </br><span>Envelope Renewal</span>',
        text: 'Comprehensive façade restoration and water intrusion prevention services.',
        img: '/assets/imgs/home/diamond/BuildingEnvelopeRenewals.jpg',
        ref: 'building-envelope-renewals'
    },
    {
        title: 'Commercial  </br><span>Exterior Painting</span>',
        text: 'Durable, weather-resistant coatings to enhance curb appeal of commercial properties.',
        img: '/assets/imgs/home/diamond/CommercialExteriorPainting.jpg',
        ref: 'commercial-exterior-painting'
    },
    {
        title: 'High-Rise &  </br><span>Mid-Rise Projects</span>',
        text: 'Specialized access solutions and surface treatments for elevated structures.',
        img: '/assets/imgs/home/diamond/High-Rise&Mid-RiseProjects.jpg',
        ref: 'high-rise-mid-rise-projects'
    },
    {
        title: 'Caulking &  </br><span>Sealant Renewal</span>',
        text: 'Precision sealing services to prevent air and moisture infiltration.',
        img: '/assets/imgs/home/diamond/Caulking&SealantRenewal.jpg',
        ref: 'caulking-sealant-renewal'
    },
    {
        title: 'Commercial  </br><span>Interior Painting</span>',
        text: 'Low-VOC interior finishes for vibrant, healthy work environments.',
        img: '/assets/imgs/home/diamond/CommercialInteriorPainting.jpg',
        ref: 'commercial-interior-painting'
    },
    {
        title: 'Waterproofing  </br><span>Systems</span>',
        text: 'Advanced membrane installation for reliable, long-term waterproof protection.',
        img: '/assets/imgs/home/diamond/WaterproofingSystems.jpg',
        ref: 'waterproofing-systems'
    },
    {
        title: 'General  </br><span>Contracting</span>',
        text: 'Turnkey project management with rigorous quality assurance and on-time delivery.',
        img: '/assets/imgs/home/diamond/GeneralContracting.jpg',
        ref: 'general-contracting'
    },
    {
        title: 'Concrete  </br><span>Restoration</span>',
        text: 'Expert crack repair and surface patching using industry-standard epoxy systems.',
        img: '/assets/imgs/home/diamond/ConcreteRestoration.jpg',
        ref: 'concrete-restoration'
    },
    {
        title: 'Balcony  </br><span>Renewal</span>',
        text: 'Balcony surface replacement and waterproofing for safe, functional outdoor spaces.',
        img: '/assets/imgs/home/diamond/BalconyRenewal.jpg',
        ref: 'balcony-renewal'
    },
    {
        title: 'Leak Investigation </br><span> & Remediation</span>',
        text: 'Cutting-edge leak detection and targeted repair solutions at the source.',
        img: '/assets/imgs/home/diamond/LeakInvestigationandRemediation.jpg',
        ref: 'leak-investigation-and-remediation'
    },
    {
        title: 'Window </br><span>Cleaning</span> ',
        text: 'Structural concrete repairs, Engineer-specified projects',
        img: '/assets/imgs/home/diamond/WindowCleaning.jpg',
        ref: 'windows-cleaning'
    },
    {
        title: 'Commercial  </br><span>Snow Removal</span>',
        text: 'Professional snow and ice removal to maintain safe, clear walkways.',
        img: '/assets/imgs/home/diamond/CommercialSnowRemoval.jpg',
        ref: 'commercial-snow-removal'
    }
];